const validHeadersCHA = {
  Name: 'name',
  'Ref Id': 'ref_id',
  'Pan Number': 'pan_number',
  'Gst Number': 'gst_number',
  'Ports Associated': 'ports_associated',
  'Admin Name': 'admin_name',
  'Email Id': 'email_id',
  'Mobile Number': 'mobile_no',
};

const CHA_SOURCE = {
  REGULAR: 1,
  BULK: 2,
  INTEGRATION: 3,
};

module.exports = {
  validHeadersCHA,
  CHA_SOURCE,
};
